"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExecutionArgumentResolver = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _ExecutionStateValueProvider = require("./ExecutionStateValueProvider");
var _ArgumentResolver = require("./ArgumentResolver");
var _ethTypes = require("@blockwell/eth-types");
var _chains = require("@blockwell/chains");
var _sourceUtil = require("../source-util");
class ExecutionArgumentResolver {
  constructor() {
    (0, _defineProperty2.default)(this, "handler", async state => {
      const provider = new _ExecutionStateValueProvider.ExecutionStateValueProvider(state);
      let args = state.dumbapp.steps.flatMap((step, stepIndex) => {
        return step.arguments.map(async (arg, argIndex) => {
          let value;
          if (arg.value) {
            let result = await provider.getArgValue(arg, step);
            if (result === null || result === undefined) {
              value = "";
            } else {
              value = await result.value();
            }
          } else {
            value = "";
          }
          let resolution = {
            type: "argument",
            step: stepIndex,
            number: argIndex,
            value: await (0, _ArgumentResolver.convertToValue)(provider, value, arg, step)
          };
          return resolution;
        });
      });

      // ETH values for the steps
      let values = state.dumbapp.steps.flatMap(async (step, stepIndex) => {
        let value = await (0, _ArgumentResolver.resolveBigNumberishSourcable)(provider, [step.value], step, _ethTypes.Typing.uint);
        if (value) {
          let converted = await (0, _ArgumentResolver.convertToValue)(provider, value, _sourceUtil.EthValueArgument, step);
          if (!converted) {
            converted = "";
          }
          if (typeof converted !== "string") {
            throw new Error(`Step ${stepIndex} value resolved into an invalid value: ${converted}`);
          }
          let resolution = {
            type: "value",
            step: stepIndex,
            value: converted
          };
          return resolution;
        }
        return null;
      });

      // Addresses for steps
      let addresses = state.dumbapp.steps.flatMap(async (step, stepIndex) => {
        let address = await (0, _ArgumentResolver.resolveAddressSourcable)(provider, [step.address], step);
        if (address) {
          let converted = await (0, _ArgumentResolver.convertToValue)(provider, address, _sourceUtil.EthAddressArgument, step);
          if (!converted) {
            converted = "";
          }
          if (typeof converted !== "string") {
            throw new Error(`Step ${stepIndex} address resolved into an invalid value: ${converted}`);
          }
          let resolution = {
            type: "address",
            step: stepIndex,
            value: converted
          };
          return resolution;
        }
        return null;
      });

      // Networks for steps
      let networks = state.dumbapp.steps.flatMap(async (step, stepIndex) => {
        let network = await (0, _ArgumentResolver.resolveStringSourcable)(provider, [step.network], step);
        if (network) {
          let converted = await (0, _ArgumentResolver.convertToValue)(provider, network, _sourceUtil.EthStringArgument, step);
          let chainId;
          if (typeof converted === "number") {
            chainId = converted;
          } else if (typeof converted === "string") {
            chainId = (0, _chains.getChain)(converted).chainId;
          } else {
            throw new Error(`Step ${stepIndex} network resolved into an invalid value: ${converted}`);
          }
          let resolution = {
            type: "network",
            step: stepIndex,
            value: chainId
          };
          return resolution;
        }
        return null;
      });
      let resolutions = await Promise.all([...args, ...values, ...addresses, ...networks]);
      return {
        success: true,
        data: resolutions.filter(it => !!it)
      };
    });
  }
}
exports.ExecutionArgumentResolver = ExecutionArgumentResolver;
//# sourceMappingURL=ExecutionArgumentResolver.js.map